import { Box, Grid, GridItem } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { ProfileInfoSkeleton } from '@/components/ui/shared/profile/ProfileInfo/ProfileInfo';
import { ProfileList } from '@/components/ui/shared/profile/ProfilesList/ProfileList';
import { queryAllLectureProfilesByLectureId } from '@/fetchers/lectureProfiles';
import { useResources } from '@/lib/datx-jsonapi-react';
import { ThinProfile } from '@/resources/ThinProfile';

export const AboutAuthorsPanel = () => {
  const { t } = useTranslation();
  const { id } = useLecturePageQueryParams();

  const { data: lectureProfiles, error } = useResources(queryAllLectureProfilesByLectureId(id));

  const profiles = lectureProfiles?.reduce((acc, lectureProfile) => {
    const type = lectureProfile.type;

    if (!acc[type]) {
      acc[type] = [];
    }

    acc[type].push(lectureProfile.profile);
    return acc;
  }, {}) as Record<'speaker' | 'author', Array<ThinProfile>>;

  return (
    <Box>
      {!lectureProfiles && !error && (
        <Grid mt={8} gap={10} templateColumns={['repeat(1, 1fr)', null, 'repeat(2, 1fr)']} alignItems="center" pr={4}>
          <GridItem>
            <ProfileInfoSkeleton />
          </GridItem>
          <GridItem>
            <ProfileInfoSkeleton />
          </GridItem>
        </Grid>
      )}
      {profiles?.speaker && profiles.speaker.length > 0 && (
        <ProfileList title={t('newLecture.aboutAuthorsSpeakersTitle')} profiles={profiles.speaker} mb={12} />
      )}
      {profiles?.author && profiles.author.length > 0 && (
        <ProfileList title={t('newLecture.aboutAuthorsOthersTitle')} profiles={profiles.author} />
      )}
    </Box>
  );
};
